var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    fill: "#3D8D4F",
    d: "m23.26351,11.91102c0.3272,-0.2929 0.3272,-0.7677 0,-1.0606c-0.3272,-0.2929 -0.85761,-0.2929 -1.18482,0l1.18482,1.0606zm-10.36719,8.2197l-0.59252,0.5304c0.3272,0.2928 0.85772,0.2928 1.18493,0l-0.59241,-0.5304zm-3.59684,-4.2803c-0.32719,-0.2929 -0.85769,-0.2929 -1.18488,0c-0.32719,0.2929 -0.32719,0.7677 0.00001,1.0606l1.18487,-1.0606zm12.77922,-5l-9.77489,8.75l1.18493,1.0607l9.77478,-8.7501l-1.18482,-1.0606zm-13.96409,6.0606l4.18919,3.7501l1.18493,-1.0607l-4.18925,-3.75l-1.18487,1.0606zm17.90785,-6.7803l1.67568,0l-1.67568,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound);
export default __webpack_public_path__ + "static/media/check-round.85097f6176031a4addf80592fdbc51ab.svg";
export { ForwardRef as ReactComponent };